var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-form-item", { attrs: { label: _vm.config.sectionTitle } }, [
    _c(
      "div",
      { staticClass: "sign-block" },
      [
        _c("el-input", {
          attrs: { placeholder: "Username", clearable: "" },
          model: {
            value: _vm.signData.username,
            callback: function($$v) {
              _vm.$set(
                _vm.signData,
                "username",
                typeof $$v === "string" ? $$v.trim() : $$v
              )
            },
            expression: "signData.username"
          }
        }),
        _vm._v(" "),
        _c("el-input", {
          staticClass: "input-with-button",
          attrs: {
            placeholder: "Password",
            type: _vm.passwordInputType,
            clearable: ""
          },
          model: {
            value: _vm.signData.password,
            callback: function($$v) {
              _vm.$set(_vm.signData, "password", $$v)
            },
            expression: "signData.password"
          }
        }),
        _vm._v(" "),
        _c("el-button", {
          staticClass: "input-button",
          attrs: {
            type: _vm.togglePasswordButtonType,
            icon: "el-icon-view",
            title: "Show/hide password"
          },
          on: { click: _vm.togglePasswordView }
        }),
        _vm._v(" "),
        _c("el-input", {
          staticClass: "input-with-button",
          attrs: { placeholder: "OTP", clearable: "" },
          model: {
            value: _vm.signData.otp,
            callback: function($$v) {
              _vm.$set(
                _vm.signData,
                "otp",
                typeof $$v === "string" ? $$v.trim() : $$v
              )
            },
            expression: "signData.otp"
          }
        }),
        _vm._v(" "),
        _c("el-button", {
          staticClass: "input-button",
          attrs: {
            type: "primary",
            icon: "el-icon-sold-out",
            title: "Paste OTP"
          },
          on: { click: _vm.pasteOtp }
        }),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: {
              size: "medium",
              type: "primary",
              icon: "el-icon-edit",
              disabled: !_vm.enableSignButton,
              loading: _vm.waitingForResponse
            },
            on: { click: _vm.signPdf }
          },
          [_vm._v("\n      " + _vm._s(_vm.config.buttonCaption) + "\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16444ec9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16444ec9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DocumentSigning.vue
// module id = null
// module chunks = 